import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import FilteredTableDataRow from './FilteredTableDataRow';
import Paper from '@mui/material/Paper';
import { IssueKeys } from '../../shared/constants/IssueAndServiceKeys';
import { ANALYTICS_CARD_BORDER_SOFT, ANALYTICS_DIVIDER, ANALYTICS_TEXT_PRIMARY } from '../Analytics/analyticsColors';
import { ANALYTICS_TITLE_FONT_FAMILY } from '../Analytics/chartTypography';
import NoDataComponent from '../Analytics/AnalyticsTable/NoDataComponent';

export default function FilteredTable({ issues, cols, dropdownTable, type }) {
  return issues?.length ? (
    <TableContainer
      component={Paper}
      sx={{
        height: '100%',
        maxHeight: '100%',
        overflow: 'auto',
        scrollbarWidth: 'thin',
        scrollbarColor: '#C5CCD8 transparent',
        '&::-webkit-scrollbar': {
          width: '8px',
          height: '8px',
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'transparent',
          marginTop: '52px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#C5CCD8',
          borderRadius: '999px',
          border: '2px solid transparent',
          backgroundClip: 'content-box',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#AFB8C7',
        },
      }}
    >
      <Table
        sx={{
          minWidth: 0,
          m: 0,
          tableLayout: 'fixed',
          backgroundColor: '#FFFFFF',
          '& .MuiTableCell-root': {
            borderColor: ANALYTICS_DIVIDER,
          },
        }}
        aria-label="simple table"
        stickyHeader
      >
        <TableHead>
          <TableRow sx={{ minHeight: '6vh', height: '6vh', maxHeight: '6vh', backgroundColor: '#FFFFFF' }}>
            {cols.map((col) => (
              <TableCell
                sx={
                  col === IssueKeys.topic
                    ? {
                        width: '50%',
                        px: '16px',
                        py: '14px',
                        borderBottom: `1px solid ${ANALYTICS_CARD_BORDER_SOFT}`,
                        color: ANALYTICS_TEXT_PRIMARY,
                        fontFamily: ANALYTICS_TITLE_FONT_FAMILY,
                        fontSize: '12.5px',
                        fontWeight: 700,
                        lineHeight: 1.35,
                        whiteSpace: 'normal',
                        overflowWrap: 'anywhere',
                        wordBreak: 'break-word',
                        verticalAlign: 'top',
                        backgroundColor: '#FFFFFF',
                        minHeight: '6vh',
                        height: '6vh',
                        maxHeight: '6vh',
                      }
                    : {
                        maxWidth: '30%',
                        px: '16px',
                        py: '14px',
                        borderBottom: `1px solid ${ANALYTICS_CARD_BORDER_SOFT}`,
                        color: ANALYTICS_TEXT_PRIMARY,
                        fontFamily: ANALYTICS_TITLE_FONT_FAMILY,
                        fontSize: '12.5px',
                        fontWeight: 700,
                        lineHeight: 1.35,
                        whiteSpace: 'normal',
                        overflowWrap: 'anywhere',
                        wordBreak: 'break-word',
                        verticalAlign: 'top',
                        backgroundColor: '#FFFFFF',
                        minHeight: '6vh',
                        height: '6vh',
                        maxHeight: '6vh',
                      }
                }
                key={col}
                align="left"
              >
                {col}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {issues.map((issue, index) => (
            <FilteredTableDataRow
              type={type}
              key={issue.id}
              issue={issue}
              columns={cols}
              dropdownTable={dropdownTable}
              isStripedRow={index % 2}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <NoDataComponent title="No data found" />
  );
}
